/*
 * landing-color-storefront.js
 *
 * Populates the product tabs on page.landing-color-storefront.liquid via the
 * Shopify Storefront API instead of per-subtype-per-color manual collections.
 *
 * For each `[data-sf-products]` container it queries the base collection
 * (data-collection) and filters products by the `slice.color_bucket` metafield
 * (data-sf-color on the root) plus in-stock availability. One batched GraphQL
 * request populates all tabs.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.single-page-content.landing-color[data-sf-domain]');
    if (!root) return;

    var domain = root.getAttribute('data-sf-domain');
    var token = root.getAttribute('data-sf-token');
    var version = root.getAttribute('data-sf-version') || '2025-01';
    var colorBucket = root.getAttribute('data-sf-color') || '';

    var containers = Array.prototype.slice.call(
      root.querySelectorAll('[data-sf-products]')
    );
    if (!containers.length || !domain || !token || !colorBucket) return;

    // Build one batched query with an alias per tab.
    var aliasFragments = containers.map(function (el, i) {
      var alias = 't' + i;
      el.setAttribute('data-sf-alias', alias);
      var handle = el.getAttribute('data-collection') || '';
      var w = parseInt(el.getAttribute('data-img-w'), 10) || 600;
      var h = parseInt(el.getAttribute('data-img-h'), 10) || 600;
      return (
        alias + ': collection(handle: ' + JSON.stringify(handle) + ') {' +
        '  products(first: 40, filters: [' +
        '    {available: true},' +
        '    {productMetafield: {namespace: "slice", key: "color_bucket", value: ' +
        JSON.stringify(colorBucket) + '}}' +
        '  ]) {' +
        '    nodes {' +
        '      handle' +
        '      title' +
        '      availableForSale' +
        '      shortTitle: metafield(namespace: "global", key: "short_title") { value }' +
        '      woodSpecies: metafield(namespace: "slice", key: "wood_species") { value }' +
        '      featuredImage { url(transform: {maxWidth: ' + w + ', maxHeight: ' + h + ', crop: CENTER}) altText }' +
        '      variants(first: 1) { nodes { id } }' +
        '    }' +
        '  }' +
        '}'
      );
    });

    var query = '{\n' + aliasFragments.join('\n') + '\n}';

    fetch('https://' + domain + '/api/' + version + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({query: query})
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (payload && payload.errors) {
          if (window.console) console.error('[color-landing] storefront errors', payload.errors);
        }
        var data = (payload && payload.data) || {};
        containers.forEach(function (el) {
          var alias = el.getAttribute('data-sf-alias');
          var collection = data[alias];
          var nodes = (collection && collection.products && collection.products.nodes) || [];
          renderTab(el, nodes);
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[color-landing] storefront fetch failed', err);
        containers.forEach(function (el) {
          el.innerHTML = '';
        });
      });
  }

  function renderTab(el, nodes) {
    var isPhoneCase = el.getAttribute('data-is-phone-case') === 'true';
    var isEdc = el.getAttribute('data-is-edc') === 'true';

    if (!nodes.length) {
      el.innerHTML = '<strong class="sold-out">This collection is sold out.</strong>';
      return;
    }

    var html = nodes
      .map(function (p) {
        var url = '/products/' + p.handle;
        var image = p.featuredImage && p.featuredImage.url ? p.featuredImage.url : '';
        var alt = (p.featuredImage && p.featuredImage.altText) || p.title || '';
        var shortTitle = (p.shortTitle && p.shortTitle.value) || p.title || '';
        var wood = isEdc && p.woodSpecies && p.woodSpecies.value ? p.woodSpecies.value : '';

        var variantGid =
          p.variants && p.variants.nodes && p.variants.nodes[0] && p.variants.nodes[0].id;
        var variantId = variantGid ? variantGid.split('/').pop() : '';

        var cta = isPhoneCase
          ? '<a href="' + url + '" class="text-button">Choose your Phone</a>'
          : variantId
            ? '<a href="/cart/add?id=' + variantId + '" class="text-button">Add to Cart</a>'
            : '';

        return (
          '<div class="card">' +
          '<span class="card-image"><a href="' + url + '">' +
          (image ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(alt) + '">' : '') +
          '</a></span>' +
          '<h3><a href="' + url + '">' + escapeHtml(shortTitle) + '</a></h3>' +
          '<div>' + escapeHtml(wood) + '</div>' +
          cta +
          '</div>'
        );
      })
      .join('');

    el.innerHTML = html;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
